/** When value is filled (true), it will display a checkbox Unicode icon */
export const checkboxFormatter = (_row, _cell, value) => value ? '&#x2611;' : '';
//# sourceMappingURL=checkboxFormatter.js.map